import { MediaGalleryState } from '../../../ImageGallery';

interface UsePreviewItemsResult {
  previewItems: MediaGalleryState[];
  moreItemsNumber: number;
  isShowMoreItems: boolean;
  maxPreviewItems: number;
}

interface UsePreviewItemsProps {
  maxImagesToPreview?: number;
  images: MediaGalleryState[];
}

function usePreviewItems({
  maxImagesToPreview,
  images,
}: UsePreviewItemsProps): UsePreviewItemsResult {
  if (maxImagesToPreview === undefined) {
    return {
      previewItems: images,
      moreItemsNumber: 0,
      isShowMoreItems: false,
      maxPreviewItems: images.length,
    };
  }
  const totalImages = images.length;
  const maxPreviewItems =
    totalImages > maxImagesToPreview
      ? maxImagesToPreview - 1
      : maxImagesToPreview;
  const previewItems = images.slice(0, maxPreviewItems);
  const moreItemsNumber = totalImages - (maxPreviewItems + 1);
  const isShowMoreItems = totalImages > maxPreviewItems;

  return {
    previewItems,
    moreItemsNumber,
    isShowMoreItems,
    maxPreviewItems,
  };
}

export default usePreviewItems;
